import * as React from 'react';
import { ImageLoaderComponentProps, ImageLoaderComponentState, ImageLoaderComponentHandler } from './imageloadercomponent';
import { ImageLoaderCSSStyle } from './imageloadercss';
import { UIDataModel } from '../uicomponent';
import { UIComponentViewImpl } from '../uicomponentview';

export class ImageLoaderViewImpl extends UIComponentViewImpl<UIDataModel>
{
    bindHandlers()
    {
        this.onSrcLoaded = this.onSrcLoaded.bind(this);
        this.onSrcError = this.onSrcError.bind(this);
    }

    draw(props: ImageLoaderComponentProps, state: ImageLoaderComponentState, cssStyle: ImageLoaderCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <>

                <img alt="" src={props.context.getResources().getImage(props.defaultImageName)} style={state.isSrcLoaded ? {display: 'none'} : cssStyle.getImgCSSStyle()}/>   
                <img onLoad={this.onSrcLoaded} onError={this.onSrcError} alt="" src={props.imagePath} style={state.isSrcLoaded ? cssStyle.getImgCSSStyle() : {display: 'none'}}/>   
             </>   
        );
    }

    private onSrcLoaded()
    {
       (super.getUIComponentHandler() as ImageLoaderComponentHandler).onSrcLoaded(true);
    }

    private onSrcError()
    {
        (super.getUIComponentHandler() as ImageLoaderComponentHandler).onSrcLoaded(false);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/imageloader/imageloaderview.tsx